<template>
  <div class="dialog_container">
    <el-dialog
      title="变更证件管理"
      :visible="dialogShow"
      width="1018px"
      @close="dialogClose"
      top="15vh"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="dialog_box">
        <div class="change_title">
          请上传格式为jpg、jpeg、png、pdf、doc、docx且大小不超过20M的图片或文件<span class="change_span">证件顺序与上一级一致</span>
        </div>
        <div class="change_img">
          <div class="certificate" @click="getImgIndex(1)">
            <el-upload
              class="avatar-uploader"
              action="http://47.101.220.89:8687/file/uploadFile"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :headers="headers"
              :http-request="uploadFile"
            >
              <div v-if="uploadData.carDrivingLicense1">
                <img
                  :src="imgHttp + uploadData.carDrivingLicense1"
                  class="avatar"
                />
              </div>
              <div v-else>
                <div class="card_title">机动车行驶证1</div>
                <img
                  class="uploading_icon"
                  src="../../../../../static/images/idCard_icon.png"
                  alt=""
                />
              </div>
            </el-upload>
          </div>
          <div class="certificate" @click="getImgIndex(2)">
            <el-upload
              class="avatar-uploader"
              action="http://47.101.220.89:8687/file/uploadFile"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :headers="headers"
              :http-request="uploadFile"
            >
              <div v-if="uploadData.carDrivingLicense2">
                <img
                  :src="imgHttp + uploadData.carDrivingLicense2"
                  class="avatar"
                />
              </div>
              <div v-else>
                <div class="card_title">机动车行驶证2</div>
                <img
                  class="uploading_icon"
                  src="../../../../../static/images/idCard_icon.png"
                  alt=""
                />
              </div>
            </el-upload>
          </div>
          <div class="certificate" @click="getImgIndex(3)">
            <el-upload
              class="avatar-uploader"
              action="http://47.101.220.89:8687/file/uploadFile"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :headers="headers"
              :http-request="uploadFile"
            >
              <div v-if="uploadData.roadTransportCertificate1">
                <img
                  :src="imgHttp + uploadData.roadTransportCertificate1"
                  class="avatar"
                />
              </div>
              <div v-else>
                <div class="card_title">道路运输证1</div>
                <img
                  class="uploading_icon"
                  src="../../../../../static/images/idCard_icon.png"
                  alt=""
                />
              </div>
            </el-upload>
          </div>
          <div class="certificate" @click="getImgIndex(4)">
            <el-upload
              class="avatar-uploader"
              action="http://47.101.220.89:8687/file/uploadFile"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :headers="headers"
              :http-request="uploadFile"
            >
              <div v-if="uploadData.roadTransportCertificate2">
                <img
                  :src="imgHttp + uploadData.roadTransportCertificate2"
                  class="avatar"
                />
              </div>
              <div v-else>
                <div class="card_title">道路运输证2</div>
                <img
                  class="uploading_icon"
                  src="../../../../../static/images/idCard_icon.png"
                  alt=""
                />
              </div>
            </el-upload>
          </div>
          <div class="certificate" @click="getImgIndex(5)">
            <el-upload
              class="avatar-uploader"
              action="http://47.101.220.89:8687/file/uploadFile"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :headers="headers"
              :http-request="uploadFile"
            >
              <div v-if="uploadData.carRegistrationCertificate">
                <img
                  :src="imgHttp + uploadData.carRegistrationCertificate"
                  class="avatar"
                />
              </div>
              <div v-else>
                <div class="card_title">机动车登记证书</div>
                <img
                  class="uploading_icon"
                  src="../../../../../static/images/idCard_icon.png"
                  alt=""
                />
              </div>
            </el-upload>
          </div>
          <div class="certificate" @click="getImgIndex(6)">
            <el-upload
              class="avatar-uploader"
              action="http://47.101.220.89:8687/file/uploadFile"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :headers="headers"
              :http-request="uploadFile"
            >
              <div v-if="uploadData.carFactoryCertificate">
                <img
                  :src="imgHttp + uploadData.carFactoryCertificate"
                  class="avatar"
                />
              </div>
              <div v-else>
                <div class="card_title">机动车整车出厂合格证</div>
                <img
                  class="uploading_icon"
                  src="../../../../../static/images/idCard_icon.png"
                  alt=""
                />
              </div>
            </el-upload>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import config from '@/utils/config';
export default {
  name: "",
  data() {
    return {
      textarea: "",
      redactForm: {},
      receiveList: [],
      uploadData: {},
      headers: {},
      imgIndex: 0,
      imgHttp: "",
      form: {
        carId: 0,
        image: "",
        isBase: 1,
        type: 1,
      },
    };
  },
  components: {},
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    carId:Number
  },
  watch:{
    dialogShow(val){
      if(val){
        this.headers = {
      Authorization: sessionStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };
    this.imgHttp = config.baseUrl;
      }
    }
  },
  created() {},
  methods: {
    confirm() {
      if (this.uploadData.carDrivingLicense1) {
        let form1 = {
          carId: this.carId,
          image: this.uploadData.carDrivingLicense1,
          isBase: 1,
          type: 1,
        };
        this.$http.updateCarCertificate(form1).then((res) => {
          console.log(res);
        });
      }
      if (this.uploadData.carDrivingLicense2) {
        let form2 = {
          carId: this.carId,
          image: this.uploadData.carDrivingLicense2,
          isBase: 1,
          type: 2,
        };
        this.$http.updateCarCertificate(form2).then((res) => {
          console.log(res);
        });
      }
      if (this.uploadData.roadTransportCertificate1) {
        let form3 = {
          carId: this.carId,
          image: this.uploadData.roadTransportCertificate1,
          isBase: 1,
          type: 3,
        };
        this.$http.updateCarCertificate(form3).then((res) => {
          console.log(res);
        });
      }
      if (this.uploadData.roadTransportCertificate2) {
        let form4 = {
          carId: this.carId,
          image: this.uploadData.roadTransportCertificate2,
          isBase: 1,
          type:4,
        };
        this.$http.updateCarCertificate(form4).then((res) => {
          console.log(res);
        });
      }
      if (this.uploadData.carRegistrationCertificate) {
        let form5 = {
          carId: this.carId,
          image: this.uploadData.carRegistrationCertificate,
          isBase: 1,
          type: 5,
        };
        this.$http.updateCarCertificate(form5).then((res) => {
          console.log(res);
        });
      }
      if (this.uploadData.carFactoryCertificate) {
        let form6 = {
          carId: this.carId,
          image: this.uploadData.carFactoryCertificate,
          isBase: 1,
          type: 6,
        };
        this.$http.updateCarCertificate(form6).then((res) => {
          console.log(res);
        });
      }
      setTimeout(()=>{
        this.$parent.getList();
        this.uploadData = {}
        this.$emit("update:dialogShow", false);
      },1000)
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
    getImgIndex(index) {
      this.imgIndex = index;
    },
    uploadFile(file) {
      var that = this;
      console.log(file);
      const formData = new FormData();
      formData.append("file", file.file);
      this.$http.uploadFile(formData).then((res) => {
        switch (that.imgIndex) {
          case 1:
            that.uploadData.carDrivingLicense1 = res.msg;
            break;
          case 2:
            that.uploadData.carDrivingLicense2 = res.msg;
            that.form = {
              carId: that.netId,
              image: that.uploadData.carDrivingLicense2,
              isBase: 1,
              type: that.imgIndex,
            };
            that.$http.updateCarCertificate(that.form).then((res) => {
              console.log(res);
            });
            break;
          case 3:
            that.uploadData.roadTransportCertificate1 = res.msg;
            that.form = {
              carId: that.netId,
              image: that.uploadData.roadTransportCertificate1,
              isBase: 1,
              type: that.imgIndex,
            };
            that.$http.updateCarCertificate(that.form).then((res) => {
              console.log(res);
            });
            break;
          case 4:
            that.uploadData.roadTransportCertificate2 = res.msg;
            that.form = {
              carId: that.netId,
              image: that.uploadData.roadTransportCertificate2,
              isBase: 1,
              type: that.imgIndex,
            };
            that.$http.updateCarCertificate(that.form).then((res) => {
              console.log(res);
            });
            break;
          case 5:
            that.uploadData.carRegistrationCertificate = res.msg;
            that.form = {
              carId: that.netId,
              image: that.uploadData.carRegistrationCertificate,
              isBase: 1,
              type: that.imgIndex,
            };
            that.$http.updateCarCertificate(that.form).then((res) => {
              console.log(res);
            });
            break;
          case 6:
            that.uploadData.carFactoryCertificate = res.msg;
            that.form = {
              carId: that.netId,
              image: that.uploadData.carFactoryCertificate,
              isBase: 1,
              type: that.imgIndex,
            };
            that.$http.updateCarCertificate(that.form).then((res) => {
              console.log(res);
            });
            break;
        }
        this.$forceUpdate();
      });
    },
    beforeAvatarUpload(file) {
      console.log(file.type);
      const isType =
        file.type == "image/jpg" ||
        file.type == "image/jpeg" ||
        file.type == "image/png" ||
        file.type == "application/pdf" ||
        file.type == "application/msword" ||
        file.type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document";;
      const isLt20M = file.size / 1024 / 1024 < 20;

      if (!isType || !isLt20M) {
        this.$message.error(
          "请上传格式为jpg、jpeg、png、pdf、doc、docx且大小不超过20M的图片或文件"
        );
      }
      return isType && isLt20M;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../redact";
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carTechnology_component/tabDialog/redactPapersResid.vue